var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdr({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_386",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28996",
    "data-name": "Group 28996",
    transform: "translate(-3746 5094)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3746, -5094)",
    filter: "url(#Ellipse_386)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_386-2",
    "data-name": "Ellipse 386",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-adr",
    transform: "translate(3764.052 -5079.019)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50553",
    "data-name": "Path 50553",
    d: "M0,0H24.735V24.735H0Z",
    transform: "matrix(0.707, -0.707, 0.707, 0.707, 0.948, 18.51)",
    fill: "#ff6f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50554",
    "data-name": "Path 50554",
    d: "M19.174,34.548,3.8,19.174,19.174,3.8,34.548,19.174ZM6.007,19.174,19.174,32.341,32.341,19.174,19.174,6.007Z",
    transform: "translate(-0.681 -0.664)",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50555",
    "data-name": "Path 50555",
    d: "M16.11,25.089H14.055l-.381,1.522H12L14.359,19h1.446l2.359,7.611h-1.6Zm-1.75-1.294h1.446l-.761-2.74Zm4.49,2.816V19h1.979a2.864,2.864,0,0,1,2.131.837A3.614,3.614,0,0,1,23.8,22.12v1.218a3.39,3.39,0,0,1-.761,2.359,2.667,2.667,0,0,1-2.207.837H18.85Zm1.522-6.317v5.023h.457a1.38,1.38,0,0,0,1.066-.381,2.146,2.146,0,0,0,.3-1.37V22.273a2.682,2.682,0,0,0-.3-1.522,1.131,1.131,0,0,0-.989-.457Zm8.3,3.12a2.378,2.378,0,0,0,1.066-2.131,2.369,2.369,0,0,0-.609-1.674A2.435,2.435,0,0,0,27.374,19H24.938v7.611h1.522v-2.74h.761l1.066,2.74h1.674v-.076Zm-.685-1.142a.742.742,0,0,1-.685.3h-.837V20.294H27.3q.913,0,.913,1.142A1.367,1.367,0,0,1,27.983,22.273Z",
    transform: "translate(-2.64 -4.296)",
    fill: "#000001"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdr);
export default __webpack_public_path__ + "static/media/ADR.32c7d9fc8d4531a29c9dec93b386b3ad.svg";
export { ForwardRef as ReactComponent };